import { Tabs } from "@closer/ui";
import { Outlet, useLocation, useNavigate } from "react-router";

import { useAuth } from "../../lib/authContext";
import { visibleOrganizationSections } from "../../lib/organizationSections";

/**
 * Organizasyon Yönetimi kabuğu (EP13 — CLOS-170 `[050]`).
 *
 * Bölümler AYRI ROTALAR, sekme durumu değil: kart *"doğrudan URL yüzeyleri"*nden söz
 * ediyor ve yöneticinin kullanıcı listesini bir bağlantı olarak paylaşabilmesi gerekiyor.
 * Sekme state'i olsaydı adres çubuğu her zaman aynı sayfayı gösterirdi.
 *
 * Hangi bölümlerin çizileceği `lib/organizationSections.ts` kaydından ve yetki filtresi
 * oradaki tek kuraldan geliyor — bu bileşen "hangi sayfalar var" sorusunu bilmiyor.
 */
export function OrganizationLayout() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const sections = visibleOrganizationSections(can);

  return (
    <div className="flex w-full flex-col gap-6">
      {/* Tek bölüm görünüyorsa gezinme çizmek anlamsız: tıklanacak bir yer yok. */}
      {sections.length > 1 ? (
        <Tabs
          label="Organizasyon yönetimi"
          items={sections.map((section) => ({ key: section.key, label: section.label }))}
          activeKey={sections.find((s) => s.route === location.pathname)?.key ?? null}
          onSelect={(key) => {
            const hedef = sections.find((s) => s.key === key);
            if (hedef) void navigate(hedef.route);
          }}
        />
      ) : null}
      <Outlet />
    </div>
  );
}
